import React from "react";
import  PictureAsPdf  from '@mui/icons-material/PictureAsPdf';
import Download  from '@mui/icons-material/Download';
import Button from "@mui/material/Button";

const ReportCart = ({ handleDownload, handleReadPdf, title, month }) => {

  return (
      <div
      style={{
        marginBottom: "10px",
        backgroundColor: '#ffffff',
        padding: '10px',
        borderRadius: '5px',
        transition: 'background-color 0.3s ease',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
      }}
      onMouseEnter={(e) => {
        e.target.style.backgroundColor = '#f1f1f1';
      }}
      onMouseLeave={(e) => {
        e.target.style.backgroundColor = '#ffffff';
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span style={{ marginRight: '10px' }}>{month} {title}</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
      <Button variant="outlined" color="success" size="small" onClick={handleDownload}  style={{ marginRight: '10px' }}>
        <Download/> Télécharger
      </Button>
     {/*  <Button variant="outlined" onClick={handleReadPdf} color="primary" size="small">
        <PictureAsPdf /> visualiser
      </Button> */}
      </div>
    </div>
  );
};

export default ReportCart;
